"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

import { Pathnames } from "~/common/utils/constants";
import {
  getOnboardedWorkspaces,
  updateOnboardedWorkspaces,
} from "~/common/utils/getOnboardedWorkspaces";

export function useWorkspaceRedirect(
  workspaceSlug?: string,
  initialPageId?: string,
) {
  const router = useRouter();

  useEffect(() => {
    if (!workspaceSlug) return;

    const onboardedWorkspaces = getOnboardedWorkspaces();
    const hasOnboarded = onboardedWorkspaces.includes(workspaceSlug);

    if (hasOnboarded || !initialPageId) {
      router.replace(`/${workspaceSlug}${Pathnames.NEW}`);
      return;
    }

    if (initialPageId) {
      updateOnboardedWorkspaces(workspaceSlug);
      router.replace(`/${workspaceSlug}${Pathnames.PAGE}/${initialPageId}`);
    }
  }, [workspaceSlug, initialPageId, router]);
}
